import { Skeleton } from '@mui/material';
import { useState } from 'react';
import PropTypes from 'prop-types';

import { navigateToMarketingSite } from '../../../utils/navigator';
import { useAuth } from '../../../context/AuthContext';
import Button from '../../../components/atoms/button';
import LogoutDialog from '../../../components/Logout';
import SimplePlanLogo from '../../../images/simple-plan-logo-black.svg';
import WorkspaceCreationStepper from './workspace-creation-stepper';

const WorkspaceCreationHeader = (props) => {
  // init
  const { step } = props;
  const { authUser } = useAuth();

  // states
  const [isOpenLogoutDialog, setIsOpenLogoutDialog] = useState(false);

  const handleDialog = () => {
    setIsOpenLogoutDialog(!isOpenLogoutDialog);
  };

  return (
    <div className="workspace-creation-header">
      <div className="workspace-creation-logo-text">
        <img width={180} src={SimplePlanLogo} alt="Simple Plan Logo" />
        <div className="workspace-email">
          <div className="workspace-skeleton-loader"><span>Confirmed as&nbsp;</span>{authUser?.email ?? <Skeleton component="span" animation="wave" variant="text" width={150} height={16} />}</div>
          <LogoutDialog
            handleDialog={handleDialog}
            openDialog={isOpenLogoutDialog}
            component={<Button disableRipple onClick={handleDialog} className="workspace-email-change-link">Change</Button>}
            setOpenDialog={setIsOpenLogoutDialog}
            onLogoutSuccess={navigateToMarketingSite}
          />
        </div>
      </div>
      <WorkspaceCreationStepper step={step} />
    </div>
  );
};

WorkspaceCreationHeader.propTypes = {
  step: PropTypes.symbol.isRequired,
};

export default WorkspaceCreationHeader;
